<template>
  <material-card2 class="v-card--material-stats" v-bind="$attrs" v-on="$listeners">
    <template v-if="!valueHeader" #subtitle>
      <div class="text-right text-h3 v-card__subtitle--material-stats" v-text="value" />
    </template>
    <template v-if="valueHeader" #heading>
      <div class="text-right text-h4 v-card__subtitle--material-stats py-4 pr-2" style="overflow: hidden">
        <div ref="fit_text" style="white-space: nowrap">
          {{ value }}
        </div>
        <v-progress-circular v-if="value == undefined" :size="40" color="secondary" indeterminate />
      </div>
    </template>
    <template #actions>
      <slot name="actions" />
    </template>

    <slot />
  </material-card2>
</template>

<script>
export default {
  name: "MaterialStatsCard",

  props: { value: [String, Number], valueHeader: Boolean },
  watch: {
    value(v) {
      if (!this.valueHeader) return;
      this.$nextTick(this.fitText);
      console.log("value chenged", this.valueHeader, v);
    },
    valueHeader(v) {
      if (v) {
        console.log("valueHeader chenged");
        this.$nextTick(this.fitText);
      }
    },
  },
  methods: {
    fitText() {
      const el = this.$refs.fit_text;
      console.log("fit text", el, this.$refs);
      if (!el) return;
      const parent = el.parentElement;
      let fontSize = 32; // максимальный размер
      const minFontSize = 14; // минимальный размер
      el.style.fontSize = fontSize + "px";
      console.log("find", parent.clientWidth, el.scrollWidth, this.value);
      while (el.scrollWidth >= parent.clientWidth && fontSize > minFontSize) {
        fontSize--;
        el.style.fontSize = fontSize + "px";
        console.log("find", parent.clientWidth, el.scrollWidth, this.value, fontSize);
      }
    },
  },
};
</script>

<style lang="sass">
.v-card--material-stats.v-card--material .v-card--material__title
  color: #999999
  font-size: .875rem !important
  margin-left: auto
  text-align: right

.v-card__subtitle--material-stats
  color: #3C4858
</style>
